import React, {
  ReactElement,
  useEffect,
  useState,
  Fragment,
  useCallback,
} from 'react';
import {
  List, ListItem, ListItemAvatar, ListItemText,
  Stack,
  Typography
} from '@mui/material';
import {useStateContext} from "../../../hooks/useStateContext";
import {AvatarMenu} from "../../../components/Header/AvatarMenu";
import api from "../../../services/api";
import CircularProgress from "@mui/material/CircularProgress";

export const NavBar = ({}: {}): ReactElement => {

  const {user, isMobile} = useStateContext();
  const [userData, setUserData] = useState<any>(null);


  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = useCallback(() => {
    api.get(`/service-provider/users/${user.id}`).then((res: any) => {
      setUserData(res);
    });
  }, []);

  return (
    <>
      <Stack
        direction={'column'}
        gap={0}
        sx={{
          '& .MuiToolbar-root.MuiTablePagination-toolbar': {
            minHeight: 'auto',
          },
        }}
      >
        <Stack
          direction={isMobile ? 'column' : "row"}
          alignItems={isMobile ? 'flex-start' : 'center'}
          justifyContent={'space-between'}
          sx={{
            background: '#fff',
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
            boxShadow: '0px 0px 10px -5px #00000091',
            p: isMobile ? '5px 10px' : '10px',
            mx: '10px',
            '& .MuiStack-root>:not(style)~:not(style)': {
              marginLeft: '0px !important',
            },
            '& .MuiButtonBase-root.MuiIconButton-root': {
              background: isMobile ? '#f3f3f3' : '',
            },
          }}
        >
          <Stack direction="row" alignItems={'center'} gap={1}>
            <Stack direction={'column'}>

              <Typography variant={'h6'} color={'#666'}>
                Foglalási Rendszer
              </Typography>
            </Stack>
          </Stack>

          <Stack direction="row" alignItems={'center'} spacing={2} gap={'2px'}>
            <img
              style={{
                height: '40px'
              }}
              src="https://zoe.stagemporium.com/public/travel-city.png"
              alt="Travel City"/>
          </Stack>

          <Stack
            direction="row"
            alignItems={'center'}
            spacing={2}
            gap={1}
            sx={{
              marginLeft: '0px !important',
            }}
          >
            <List
              sx={{
                padding: '0px'
              }}
              dense={true}
            >
              <ListItem
                alignItems="center"
                sx={{
                  flexDirection: 'row-reverse',
                  padding: '0px'
                }}
              >
                <ListItemAvatar
                  sx={{
                    margin: '0px'
                  }}
                >
                  <AvatarMenu
                    background={'#21a9a9'}
                    showNotifications={false}
                    showOnlineUsers={false}
                    showUserManagement={false}
                  />
                </ListItemAvatar>
                {!userData ? (
                  <>
                    <CircularProgress/>
                  </>
                ) : (
                  <ListItemText
                    sx={{
                      margin: '0px',
                      textAlign: 'right'
                    }}
                    primary={
                      <>
                        {userData.service_providers.map((userItem: any) => {
                          return (
                            <b style={{
                              fontSize: '17px',
                              background: '#e1e1e1',
                              padding: '2px 6px',
                              borderRadius: '20px',
                              marginRight: '2px',
                            }}>{userItem?.name}</b>
                          );
                        })}
                      </>
                    }
                    secondary={user?.name || '-'}
                  />
                )}

              </ListItem>
            </List>
          </Stack>
        </Stack>

      </Stack>
    </>
  );
};
